import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {RestService} from "../rest.service.interface";
import {RestServiceImpl} from "../rest.service.impl";
import {LoggerService} from "../../../shared/logger.service";
import {Datei} from "../../datei/datei.model";
import {DateiArt} from "../../datei/dateiart.model";
import {AuthService} from "../../../shared/auth.service";
import {ImagesSelectComponent} from "../bild/images.select.component";
import {ImagesUploadComponent} from "../bild/images.upload.component";
import {InsertEditMitDialogs} from "./insertEdit.mitDialogs";
import {APIConfigService} from "../../../api.config.service";
import {HttpClient} from "@angular/common/http"; import {FormsModule} from "@angular/forms";
import {AngularMaterial2Module} from "../../../app.module.material";
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';

const PATH_FILE = 'app/protected/immerdrin/bearbeitung/insertEdit.mitDatei.ts';

@Component({
    selector: 'oase-thema-insertEdit.mitDatei',
    templateUrl: './insertEdit.mitDatei.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true,	imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule  ]

})
export class InsertEditMitDatei extends InsertEditMitDialogs {

    constructor(
        public dialogRef: MatDialogRef<InsertEditMitDatei>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dataService: RestService,
        public authService: AuthService,
		public apiConfigService: APIConfigService,
		public http: HttpClient,
        public dialog: MatDialog,
        public _logger: LoggerService) {

        super(dialogRef, data, dataService, authService, apiConfigService, http, dialog, _logger);

    }

    protected onDropModel(args) {
        let [el, target, source] = args;
        // do something else
    }

    protected onRemoveModel(args) {
        let [el, source] = args;
        // do something else
    }

  getBildVerkleinertUrl(datei: Datei, zusatz: string = ''): string {
    if(datei != null && datei.art == DateiArt[DateiArt.BILD]) {
        let authUrl = this.authService.getAuthUrl(datei.url + zusatz);
        return authUrl;
    }
    return null;
  }

	entferneDatei(index: number){
		// to override
		// e.g. this.aktuell.anhang.splice(index,1);
	}

    zeigeDateiuploadMaske(nurBild: boolean = true) {
        this._logger.log(PATH_FILE + ' - zeigeDateiuploadMaske');

        const dialogRefImageUpload = this.dialog.open(ImagesUploadComponent, {
            width: '600px',
            data: {
                aktuell: this.aktuell,
                OBJ_LNG_NAME: this.OBJ_LNG_NAME,
                BACKEND_PATH_PREFIX: this.BACKEND_PATH_PREFIX,
                nurBild: nurBild,
				setDatei: this.setDatei.bind(this),
            }
        });


    } // zeigeDateiuploadMaske

    zeigeDateiauswahlMaske(nurBild: boolean = true) {
        this._logger.log(PATH_FILE + ' - zeigeDateiauswahlMaske');

        const dialogRefImageSelect = this.dialog.open(ImagesSelectComponent, {
            width: '600px',
            data: {
                aktuell: this.aktuell,
                OBJ_LNG_NAME: this.OBJ_LNG_NAME,
                BACKEND_PATH_PREFIX: this.BACKEND_PATH_PREFIX,
                nurBild: nurBild,
				setDatei: this.setDatei.bind(this),
            }
        });

    } // zeigeDateiauswahlMaske

    getDatei() : Datei {
		return null;
		// to override, not really used
    }

	setDatei(datei: any) {
		// to override, passed to image select/upload handlers
	}


}
